module.exports = __webpack_public_path__ + "img/rosa.7aec1437.png";